import { createContext, useContext, useEffect, useState } from "react";
import { useAuthContext } from "./AuthContext";
import axios from "axios";
import { URL_API } from "config";

const SocketContext = createContext();

export const SocketProvider = ({ children, ...rest }) => {
  const [messages, setMessages] = useState([]);

  const { authenticated, user } = useAuthContext();

  useEffect(() => {
    const interval = setInterval(async () => {
      let usr = user;

      if (typeof usr === 'string') usr = JSON.parse(usr);

      if (authenticated) {
        const response = await axios.get(URL_API + `/send-messages?page=1&limit=200&visualized=false`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Tag")}`,
          },
        });

        setMessages(response?.data?.data);
      }
    }, 5000);

    return () => clearInterval(interval);
  });

  return (
    <SocketContext.Provider value={{ messages }}>
      {children}
    </SocketContext.Provider>
  )
}

export const useSocketContext = () => {
  const { messages } = useContext(SocketContext);

  return { messages }
};
